<template>
<div>
  <div ref="map" style="width: 100%; height: 250px">
  </div>
</div>
 
</template>

<script>
import * as am5 from "@amcharts/amcharts5";
import * as am5map from "@amcharts/amcharts5/map";
import am5geodata_worldLow from "@amcharts/amcharts5-geodata/ukHigh";
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';

export default {
  props: ['settings', 'value'],
  mounted () {
    //alert('ddd');
    let root = am5.Root.new(this.$refs.map);

    if (root.logo) {
      root.logo.disabled = true
    }
    root.setThemes([
      am5themes_Animated.new(root)
    ]);

    var chart = root.container.children.push(
      am5map.MapChart.new(root, {
        panX: "rotateX",
        projection: am5map.geoNaturalEarth1()
      })
    );

    // Create polygon series
    var polygonSeries = chart.series.push(
      am5map.MapPolygonSeries.new(root, {
        geoJSON: am5geodata_worldLow,
        exclude: ["GB-WLS", "GB-SCT", "IE", "GB-NIR", "IM", "JE", "GG"]
      })
    );

    polygonSeries.mapPolygons.template.setAll({
      tooltipText: "{name}",
      templateField: "polygonSettings",
      fill: am5.color(0xd1d1d1),
    });

    polygonSeries.data.setAll(this.settings.map(item => {
      return {
        id: item.id,
        polygonSettings: {
          fill: am5.color(item.color),
          opacity: item.opacity,
          tooltipText: "{name} " + new Intl.NumberFormat('en', { notation: "compact", compactDisplay: "short"}).format(item.value)
        }
      }
    }))
    
    console.log('settings', this.settings)
  },
}
</script>

<style>

</style>